import { render, staticRenderFns } from "./logisticsmode.vue?vue&type=template&id=4f44cb3a&scoped=true&"
import script from "./logisticsmode.vue?vue&type=script&lang=js&"
export * from "./logisticsmode.vue?vue&type=script&lang=js&"
import style0 from "./logisticsmode.vue?vue&type=style&index=0&id=4f44cb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f44cb3a",
  null
  
)

export default component.exports